"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_BREAKPOINT = 960;
